export abstract class AuthenticationConst {

    /**
     * The API prefix for the authentication API
     * @readonly
     * @type {string}
     * @description The API prefix for the authentication API
     */
    public static readonly AUTH_API_PREFIX = '';

    /**
     * The endpoint for the login API
     * @readonly
     * @type {string}
     * @description The endpoint for the login API
     */
    public static readonly LOGIN_ENDPOINT = `login`;

    /**
     * The endpoint for the refresh API
     * @readonly
     * @type {string}
     * @description The endpoint for the refresh API
     */
    public static readonly REFRESH_ENDPOINT = `${AuthenticationConst.LOGIN_ENDPOINT}/refresh`;

    /**
     * The endpoint for the logout API
     * @readonly
     * @type {string}
     * @description The endpoint for the logout API
     */
    public static readonly LOGOUT_ENDPOINT = `logout`;

}
